import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityNotes } from "@modernary/mui/components/note";
import { EntityDocuments } from "@modernary/mui/components/document";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  applications: "Application.Applications",
  list: "Application.ApplicationList",
  new: "Application.ApplicationNew",
  newSelect: "Application.ApplicationNewSelect",
  base: "Application.ApplicationBase",
  view: "Application.ApplicationView",
  edit: "Application.ApplicationEdit",
  complete: "Application.ApplicationComplete",
  withdraw: "Application.ApplicationWithdraw",
  notes: "Application.ApplicationNotes",
  noteEdit: "Application.ApplicationNoteEdit",
  noteNew: "Application.ApplicationNoteNew",
  documents: "Application.ApplicationDocuments",
  documentEdit: "Application.ApplicationDocumentEdit",
  documentNew: "Application.ApplicationDocumentNew",
  audit: "Application.ApplicationAudit",
};

export { names as applicationRouteNames };

const applicationRoutes: RouterOptions["routes"] = [
  {
    path: "/applications",
    name: names.applications,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Applications", lookupGroups: ["ApplicationType", "PermitType", "ApplicationStatus"] },
        component: () => import("@/views/application/ApplicationList.vue"),
      },
      {
        //(Initial|Modification|Renewal)
        path: "new/:typeMurn?/:facilitySiteId(\\d+)?/:permitId(\\d+)?",
        component: () => import("@/views/application/ApplicationBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Application", isNew: true },
            component: () => import("@/views/application/ApplicationEdit.vue"),
          },
          {
            path: "select",
            name: names.newSelect,
            meta: { title: "New Application", isNew: true },
            component: () => import("@/views/application/ApplicationSelect.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/application/ApplicationBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Application View" },
            component: () => import("@/views/application/ApplicationView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Application Edit", isForm: true },
            component: () => import("@/views/application/ApplicationEdit.vue"),
          },
          {
            path: "complete",
            name: names.complete,
            meta: { title: "Complete Application", isForm: true },
            component: () => import("@/views/application/ApplicationComplete.vue"),
          },
          {
            path: "withdraw",
            name: names.withdraw,
            meta: { title: "Withdraw Application", isForm: true },
            component: () => import("@/views/application/ApplicationWithdraw.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Application Internal Notes" },
            component: {
              render: () => <EntityNotes idField="applicationId" routeNamePrefix="Application.ApplicationNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Application Internal Note", isForm: true },
            component: () => import("@/views/application/ApplicationNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Application Internal Note", isForm: true },
            component: () => import("@/views/application/ApplicationNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Application Documents" },
            component: {
              render: () => (
                <EntityDocuments idField="applicationId" routeNamePrefix="Application.ApplicationDocument" />
              ),
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Application Document", isForm: true },
            component: () => import("@/views/application/ApplicationDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Application Document", isForm: true },
            component: () => import("@/views/application/ApplicationDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Application Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Application" />,
            },
          },
        ],
      },
    ],
  },
];
export default applicationRoutes;
